"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/serviceSectiion.tsx */

import { SmartImage } from "@/Components";
import { NextArrow, PrevArrow } from "../../Components/SliderArrows";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSectiionServicesFoursItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/service-08.svg" | "/Templates/Doccure/img/icons/service-09.svg" | "/Templates/Doccure/img/icons/service-10.svg" | "/Templates/Doccure/img/icons/service-11.svg" */
    src: string;
    /** Detected variants: "Newborn & Infant Care" | "Growth & Development" | "Immunizations" | "Common Illness" */
    h30Text: ReactNode;
    /** Detected variants: "Compassionate care for newborns ensuring healthy growth." | "Supporting every stage of your child’s growth with checkups." | "Complete immunization support with scheduled vaccines." | "Reliable care for colds, fevers, infections, and other common childhood illnesses." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/service-01.jpg" | "/Templates/Doccure/img/service/service-02.jpg" | "/Templates/Doccure/img/service/service-03.jpg" | "/Templates/Doccure/img/service/service-04.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "services-item-four" */
    className?: string;
    /** Detected variants: "service-content" */
    div0ClassName?: string;
    /** Detected variants: "service-icon" */
    div0ClassName2?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "service-info" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "service" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName2?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false,
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
            },
        },
    ],
};

export type HomeFourServiceSectiionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectiionServicesFoursItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSectiionServicesFoursItem) => Partial<ComponentProps<"h3">>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectiionServicesFoursItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Our Solutions" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Professional Services Tailored for Comprehensive" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Pediatric Care" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    serviceSectiionServicesFours: ServiceSectiionServicesFoursItem[];
    serviceSectiionServicesFoursItemWrapper?: (item: ServiceSectiionServicesFoursItem, content: ReactNode) => ReactNode;
    serviceSectiionServicesFoursRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSectiionServicesFoursImageVisible?: boolean;
    serviceSectiionServicesFoursImageRenderer?: (item: ServiceSectiionServicesFoursItem, defaultNode: ReactNode) => ReactNode;
    serviceSectiionServicesFoursH3Visible?: boolean;
    serviceSectiionServicesFoursH3Renderer?: (item: ServiceSectiionServicesFoursItem, defaultNode: ReactNode) => ReactNode;
    serviceSectiionServicesFoursImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectiionServicesFoursItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    serviceSectiionServicesFoursH3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSectiionServicesFoursItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourServiceSectiionGenerated: FC<HomeFourServiceSectiionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "Our Solutions",
    sectionDiv0Div0Div0Div0H20H2Text = "Professional Services Tailored for Comprehensive",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Pediatric Care",
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divImageWithBasePath0ImageProps,
    sectionDiv0Slider0SliderProps,
    sectionDiv0Div0ClassName,
    serviceSectiionServicesFours,
    serviceSectiionServicesFoursItemWrapper,
    serviceSectiionServicesFoursRenderer,
    serviceSectiionServicesFoursImageVisible,
    serviceSectiionServicesFoursImageRenderer,
    serviceSectiionServicesFoursH3Visible,
    serviceSectiionServicesFoursH3Renderer,
    serviceSectiionServicesFoursImageProps,
    serviceSectiionServicesFoursH3Props,
}) => {
    return (
        <section className="service-section-four section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-7 mx-auto">
                        <div className="section-header section-header-four text-center">
                            <div className="section-sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    {" "}
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                    </div>
                </div>
                <Slider {...settings} className="service-slider" {...(sectionDiv0Slider0SliderProps ?? {})}>
                    {renderCollectionNode(
                        serviceSectiionServicesFours,
                        (item: ServiceSectiionServicesFoursItem) => (
                            <div className={item.className ?? "services-item-four"} key={item.key}>
                                {renderItemNode(serviceSectiionServicesFoursImageVisible, serviceSectiionServicesFoursImageRenderer, item, (
                                    <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "service"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid"} {...(typeof serviceSectiionServicesFoursImageProps === "function" ? serviceSectiionServicesFoursImageProps(item) : (serviceSectiionServicesFoursImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                                <div className={item.div0ClassName ?? "service-content"}>
                                    <div className={item.div0ClassName2 ?? "service-icon"}>
                                        {renderItemNode(serviceSectiionServicesFoursImageVisible, serviceSectiionServicesFoursImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof serviceSectiionServicesFoursImageProps === "function" ? serviceSectiionServicesFoursImageProps(item) : (serviceSectiionServicesFoursImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "service-info"}>
                                        {renderItemNode(serviceSectiionServicesFoursH3Visible, serviceSectiionServicesFoursH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof serviceSectiionServicesFoursH3Props === "function" ? serviceSectiionServicesFoursH3Props(item) : (serviceSectiionServicesFoursH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        serviceSectiionServicesFoursItemWrapper,
                        serviceSectiionServicesFoursRenderer
                    )}
                </Slider>
            </div>
        </section>
    );
};

export default HomeFourServiceSectiionGenerated;
